import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Calendar, CheckCircle, ChevronRight } from 'lucide-react';

const Experience = ({ experiences }) => {
  return (
    <section id="expériences" className="py-20 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="bg-violet-600/20 p-3 rounded-full">
            <Briefcase className="text-violet-400" size={28} />
          </div>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-1">Expériences</h2>
            <div className="text-xs font-mono text-gray-500">$ ls ./career/</div>
          </div>
        </div>

        <div className="space-y-6 relative">
          {/* Ligne de temps verticale */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-gradient-to-b from-violet-500 via-fuchsia-500 to-blue-500 opacity-30" />

          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
              className="relative pl-16"
            >
              {/* Point sur la timeline */}
              <div className="absolute left-6 top-6 w-4 h-4 bg-violet-500 rounded-full border-4 border-dark-surface" />
              
              <div className="bg-dark-surface rounded-xl p-6 border border-violet-500/20 hover:border-violet-500/50 transition-all duration-300">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-violet-400">{exp.title}</h3>
                  {exp.period && (
                    <div className="flex items-center gap-2 text-gray-400 mt-2 md:mt-0 font-mono text-sm">
                      <Calendar size={14} />
                      <span>{exp.period}</span>
                    </div>
                  )}
                </div>
                
                {exp.company && (
                  <p className="text-base text-gray-300 mb-3 font-mono">
                    <span className="text-gray-500">🏢</span> {exp.company}
                  </p>
                )}
                
                {exp.description && (
                  <p className="text-gray-400 mb-4 text-sm italic">{exp.description}</p>
                )}
                
                <ul className="space-y-2">
                  {exp.achievements.map((achievement, i) => (
                    <li key={i} className="flex items-start gap-2 text-gray-300 text-sm">
                      <CheckCircle size={16} className="text-green-400 flex-shrink-0 mt-0.5" />
                      <span>{achievement}</span>
                    </li>
                  ))}
                </ul>

                {/* Lien pour plus de détails */}
                <div className="mt-4 flex justify-end">
                  <button className="flex items-center gap-1 text-xs text-violet-400 hover:text-violet-300 transition-colors font-mono">
                    <span>$ cat details</span>
                    <ChevronRight size={12} />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Experience;